import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function Productvideodemo() {
  return <section data-section-id="253759" id="productvideodemo" className="bg-background py-10 md:py-14 text-foreground">
      <div className="container mx-auto px-4 max-w-5xl text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-foreground">
          Porqué necesitas un SBC y no sirve un router
        </h2>
        <div className="w-full overflow-hidden rounded-lg shadow-xl border border-border bg-muted/20 transition-transform hover:scale-[1.01] duration-300">
          <AspectRatio ratio={16 / 9}>
            <iframe className="w-full h-full rounded-lg" src="https://www.youtube.com/embed/Yu8UJs8obW8" title="YouTube video demo - SBC vs Router" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </AspectRatio>
        </div>
      </div>
    </section>;
}